import { type ReactNode } from "react";
import { Navigate } from "react-router";
import { AUDIT_LOG, useFoodpilotContext, VIEW } from "src/context/FoodpilotContext";
import { hasPermissionOnPlatformOrAnyOrganization } from "src/context/permissionMatching";

type AuditLogProtectionProps = {
    children: ReactNode;
};

export const AuditLogProtection = (props: AuditLogProtectionProps) => {
    const { children } = props;
    const { user } = useFoodpilotContext();

    if (!hasPermissionOnPlatformOrAnyOrganization(user.trustedUser, VIEW, AUDIT_LOG)) {
        return <Navigate to="/settings" replace />;
    }

    return children;
};
